import { YAxisProps } from "recharts";
import {
  AxisValueFormat,
  axisTickFormatter,
} from "./format-axis-value";

export type YAxisConfigOptions = YAxisProps & {
  logScale?: boolean;
  valueFormat?: AxisValueFormat;
};

export function yAxisConfig(options?: YAxisConfigOptions) {
  const {
    logScale = false,
    valueFormat = "compact",
    width = 76,
    domain: domainOverride,
    ...rest
  } = options ?? {};

  const base = {
    stroke: "rgba(255,255,255,0.12)",
    tick: { fill: "rgba(255,255,255,0.55)", fontSize: 11 },
    tickLine: false,
    tickMargin: 8,
    width,
    type: "number" as const,
    allowDataOverflow: true,
    tickFormatter: axisTickFormatter(valueFormat),
    ...rest,
  };

  if (logScale) {
    return {
      ...base,
      scale: "log" as const,
      domain: domainOverride ?? ([1, "auto"] as const),
    } as YAxisProps;
  }

  return {
    ...base,
    scale: "linear" as const,
    domain: domainOverride ?? (["auto", "auto"] as const),
  } as YAxisProps;
}

export default yAxisConfig;
